var exports = {
  "kL": "VideoPlayer.module__container___TmFOU2",
  "Ki": "VideoPlayer.module__video___TmFOU2",
  "ER": "VideoPlayer.module__videoHidden___TmFOU2",
  "mz": "VideoPlayer.module__seekPreviewVideo___TmFOU2",
  "IN": "VideoPlayer.module__posterOverlay___TmFOU2",
  "lW": "VideoPlayer.module__posterImage___TmFOU2",
  "aO": "VideoPlayer.module__thumbHashPlaceholder___TmFOU2",
  "HT": "VideoPlayer.module__playOverlayButton___TmFOU2",
  "$Z": "VideoPlayer.module__controlsOverlay___TmFOU2",
  "hr": "VideoPlayer.module__progressBar___TmFOU2",
  "xu": "VideoPlayer.module__controlsRow___TmFOU2",
  "it": "VideoPlayer.module__controlsLeft___TmFOU2",
  "QE": "VideoPlayer.module__controlsCenter___TmFOU2",
  "BT": "VideoPlayer.module__controlsRight___TmFOU2",
  "sL": "VideoPlayer.module__playPauseIndicator___TmFOU2",
  "HA": "VideoPlayer.module__fillContainer___TmFOU2",
  "Y5": "VideoPlayer.module__fullscreen___TmFOU2",
};

module.exports = exports;
